import { SidebarMobile } from './SidebarMobile'

export default SidebarMobile
